<template>
  <section class="card_style mt-0">
    <div class="d-flex align-items-center gap-3">
      <AddFavDailog v-tooltip.left="$t('add_to_favourite')" />
      <h4 class="mb-0">
        <span v-if="blog_id">{{ $t("edit blog") }}</span>
        <span v-else>{{ $t("add blog") }}</span>
      </h4>
    </div>

    <form @submit.prevent="addBlog()">
      <div class="row">
        <div class="row crop_image">
          <!--          <button class="btn PrimaryButton">Upload Image</button>-->
          <input
            type="file"
            @change="onFileChangeCrop"
            accept="image/*"
            @click="visible = true"
          />

          <Dialog
            v-model:visible="visible"
            modal
            header="Crop Image"
            :closable="false"
            class="crop_image_dialog"
          >
            <div v-if="imageSrc" class="imageSrc imageSrcropper px-0 mb-3">
              <img ref="image" :src="imageSrc" alt="Source" />
            </div>
            <button
              v-if="imageSrc"
              type="button"
              class="btn PrimaryButton"
              @click="cropImage"
            >
              Crop
            </button>
          </Dialog>
          <div v-if="croppedImage" class="croppedImage">
            <h3>Cropped Image:</h3>
            <img :src="croppedImage" alt="Cropped" />
          </div>
        </div>
        <div class="col-lg-12 col-md-12 col-12">
          <label for="">{{ $t("blog_title") }}</label>
          <TabView>
            <TabPanel
              v-for="(title, index) in Form.title"
              :key="index"
              :header="$t('blog_title') + ' - ' + title.lang"
            >
              <div class="form-group">
                <input
                  :placeholder="$t('blog_title')"
                  class="form-control"
                  :id="`title${index}`"
                  v-model="title.name"
                />
              </div>
            </TabPanel>
          </TabView>
        </div>
        <div class="col-lg-12 col-md-12 col-12">
          <label for="">{{ $t("blog_content") }}</label>
          <TabView>
            <TabPanel
              v-for="(desc, index) in Form.subtitle"
              :key="index"
              :header="$t('blog_content') + ' - ' + desc.lang"
            >
              <div class="form-group">
                <Editor
                  :placeholder="$t('blog_content')"
                  class="form-control"
                  :id="`desc${index}`"
                  v-model="desc.name"
                />
              </div>
            </TabPanel>
          </TabView>
        </div>
        <div class="col-lg-6 col-md-6 col-12" v-if="type === 'website'">
          <div class="form-group">
            <label for="">{{ $t("categotey-blogs") }}</label>
            <!-- {{ categoryBlogs }} -->
            <Multiselect
              v-model="categoryBlogs"
              :options="categoriesBlogs"
              :clear-on-select="true"
              :placeholder="$t('categotey-blogs')"
              label="title"
              track-by="id"
              select-label=""
              :hide-selected="true"
            >
            </Multiselect>
            <!--            <span-->
            <!--              class="text-danger"-->
            <!--              v-if="v$.categoryBlogs.$error"-->
            <!--              v-text="v$.categoryBlogs.$errors[0].$message"-->
            <!--            ></span>-->
          </div>
        </div>
        <div class="col-lg-6 col-md-6 col-12" v-if="type === 'website'">
          <div class="form-group">
            <label for="">{{ $t("hastag-blogs") }}</label>
            <!-- {{ categoryBlogs }} -->
            <Multiselect
              v-model="hashTagBlogs"
              :options="hashtagsBlogs"
              :clear-on-select="true"
              :placeholder="$t('hastag-blogs')"
              label="title"
              track-by="id"
              select-label=""
              :hide-selected="true"
              :multiple="true"
            >
            </Multiselect>
            <!--            <span-->
            <!--              class="text-danger"-->
            <!--              v-if="v$.hashTagBlogs.$error"-->
            <!--              v-text="v$.hashTagBlogs.$errors[0].$message"-->
            <!--            ></span>-->
          </div>
        </div>
        <div class="col-lg-6 col-md-6 col-12">
          <div class="form-group">
            <label for="alt"> {{ $t("alt_image") }}</label>
            <input
              type="text"
              name="alt"
              id="alt"
              class="form-control"
              v-model="alt"
            />
          </div>
        </div>
        <div class="col-lg-6 col-md-6 col-12">
          <div class="form-group">
            <label for="slug"> {{ $t("slug") }}</label>
            <input
              type="text"
              name="slug"
              id="alt"
              class="form-control"
              v-model="slug"
            />
            <!--            <span-->
            <!--              class="text-danger"-->
            <!--              v-if="v$.slug.$error"-->
            <!--              v-text="v$.slug.$errors[0].$message"-->
            <!--            ></span>-->
          </div>
        </div>
        <div class="col-lg-6 col-md-6 col-12">
          <label for="">{{ $t("meta_title") }}</label>
          <TabView>
            <TabPanel
              v-for="(meta_title, index) in Form.meta_title"
              :key="index"
              :header="$t('meta_title') + ' - ' + meta_title.lang"
            >
              <div class="form-group">
                <input
                  :placeholder="$t('meta_title')"
                  class="form-control"
                  :id="`meta_title${index}`"
                  v-model="meta_title.name"
                />
              </div>
            </TabPanel>
          </TabView>
        </div>
        <div class="col-lg-6 col-md-6 col-12">
          <div class="form-group">
            <label for="">{{ $t("meta_describtion") }}</label>
            <TabView>
              <TabPanel
                v-for="(meta_description, index) in Form.meta_description"
                :key="index"
                :header="$t('meta_description') + ' - ' + meta_description.lang"
              >
                <div class="form-group">
                  <textarea
                    :placeholder="$t('meta_description')"
                    class="form-control"
                    :id="`meta_description${index}`"
                    v-model="meta_description.name"
                  ></textarea>
                </div>
              </TabPanel>
            </TabView>
          </div>
        </div>
      </div>
      <button type="submit" class="add btn PrimaryButton">
        {{ $t("save") }}
      </button>
    </form>
  </section>
</template>

<script>
import axios from "axios";
import Swal from "sweetalert2";
import Multiselect from "vue-multiselect";
import AddFavDailog from "@/components/layout/addFavDailog.vue";
import useVuelidate from "@vuelidate/core";
import { required } from "@vuelidate/validators";
import TabView from "primevue/tabview";
import TabPanel from "primevue/tabpanel";
import Editor from "primevue/editor";
import Cropper from "cropperjs";
import Dialog from "primevue/dialog";

export default {
  name: "blogsWebsiteAdd",
  data() {
    return {
      v$: useVuelidate(),
      alt: "",
      categoriesBlogs: [],
      categoryBlogs: "",
      hashtagsBlogs: [],
      hashTagBlogs: "",
      slug: "",
      languages: ["ar", "en"],
      options: {
        placeholder: this.$t("describtion"),
        theme: "snow",
      },
      Form: {
        title: [],
        subtitle: [],
        meta_description: [],
        meta_title: [],
      },
      imageEntry: "",
      defaultImage: require("@/assets/media/image/user.png"),
      blog_id: undefined,
      type: this.$route.params.type,
      imageSrc: null,
      croppedImage: null,
      cropper: null,
      visible: false,
    };
  },
  components: {
    Editor,
    Multiselect,
    AddFavDailog,
    TabView,
    TabPanel,
    Dialog,
  },
  validations() {
    return {
      // imageEntry: {
      //   required,
      // },

      // categoryBlogs: {
      //   required,
      // },
      // hashTagBlogs: {
      //   required,
      // },
      Form: {
        title: this.Form.title.map(() => {
          return {
            name: {
              required,
            },
          };
        }),
        subtitle: this.Form.subtitle.map(() => {
          return {
            name: {
              required,
            },
          };
        }),
      },
    };
  },
  methods: {
    setBlogTitle() {
      this.languages.forEach((language) => {
        this.Form.title.push({
          lang: language,
          name: "",
        });
        this.Form.subtitle.push({
          lang: language,
          name: "",
        });
        this.Form.meta_description.push({
          lang: language,
          name: "",
        });
        this.Form.meta_title.push({
          lang: language,
          name: "",
        });
      });
    },
    addBlog() {
      // this.v$.$validate();
      // if (!this.v$.$error) {
      const payload = {
        is_portal: this.$route.params.type === "portal" ? 1 : 0,
        // Convert titles
        title_en:
          this.Form?.title?.find((ele) => ele.lang === "en")?.name || "",
        title_ar:
          this.Form?.title?.find((ele) => ele.lang === "ar")?.name || "",

        blog_id: this.$route.params.id,

        // Convert contents
        content_en:
          this.Form?.subtitle?.find((ele) => ele.lang === "en")?.name || "",
        content_ar:
          this.Form?.subtitle?.find((ele) => ele.lang === "ar")?.name || "",

        // Convert meta descriptions
        meta_description_en:
          this.Form?.meta_description?.find((ele) => ele.lang === "en")?.name ||
          "",
        meta_description_ar:
          this.Form?.meta_description?.find((ele) => ele.lang === "ar")?.name ||
          "",

        // Convert meta titles
        meta_title_en:
          this.Form?.meta_title?.find((ele) => ele.lang === "en")?.name || "",
        meta_title_ar:
          this.Form?.meta_title?.find((ele) => ele.lang === "ar")?.name || "",
      };

      if (this.croppedImage.startsWith("data:image/")) {
        {
          payload.image = this.croppedImage;
        }
      }

      if (this.$route.params.id !== undefined) {
        axios
          .post(`/update_blog`, payload)
          .then(({ data }) => {
            Swal.fire({
              title: "",
              text: data.message,
              icon: "success",
            });
            this.$router.push(
              `/blogs/${this.$route.params.type === "portal" ? "portal" : "website"}`
            );
          })
          .catch((error) => {
            console.log(error);
            Swal.fire({
              title: "",
              text: error.response.data.message,
              icon: "error",
            });
          });
      } else {
        axios
          .post(`/store_blog`, payload)
          .then(({ data }) => {
            Swal.fire({
              title: "",
              text: data.message,
              icon: "success",
            });
            this.$router.push(
              `/blogs/${this.$route.params.type === "portal" ? "portal" : "website"}`
            );
          })
          .catch((error) => {
            console.log(error);
            Swal.fire({
              title: "",
              text: error.response.data.message,
              icon: "error",
            });
          });
      }
      // }

      // console.log(this.v$);
    },
    fetchBlog() {
      if (this.$route.params.id !== undefined) {
        this.blog_id = this.$route.params.id;
        axios.post(`/show_blog`, { blog_id: this.blog_id }).then(({ data }) => {
          this.Form.title = data.data.titles
            .map((ele) => {
              return { lang: ele.locale, name: ele.title };
            })
            .filter((ele) => {
              return ele.name !== null;
            });
          this.Form.subtitle = data.data.contents
            .map((ele) => {
              return { lang: ele.locale, name: ele.content };
            })
            .filter((ele) => {
              return ele.name !== null;
            });
          this.Form.meta_description = data.data.meta_descriptions
            ?.map((ele) => {
              return { lang: ele.locale, name: ele.meta_description };
            })
            .filter((ele) => {
              return ele.name !== null;
            });
          this.Form.meta_title = data.data.meta_titles
            ?.map((ele) => {
              return { lang: ele.locale, name: ele.meta_title };
            })
            .filter((ele) => {
              return ele.name !== null;
            });
          this.slug = data.data.slug;
          this.alt = data.data.alt;
          this.croppedImage = data.data.image;
          this.categoryBlogs = data.data.blog_category;
          this.hashTagBlogs = data.data.hashtag_blogs;
        });
      }
    },
    fetch_categories() {
      axios.post("/index_blog_categories").then(({ data }) => {
        this.categoriesBlogs = data.data.data;
        // console.log(data.data.data);
      });
    },
    hashtag_categories() {
      axios.post(`/index_hashtag_blogs`).then(({ data }) => {
        this.hashtagsBlogs = data.data.data;
        // console.log(this.hashtagsBlogs);
      });
    },
    onFileChangeCrop(event) {
      this.fileData = event.target.files[0];
      if (this.fileData) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.imageSrc = e.target.result;
          this.$nextTick(() => {
            if (this.cropper) {
              this.cropper.destroy();
            }
            this.cropper = new Cropper(this.$refs.image, {
              aspectRatio: 16 / 9, // Adjust as needed
              viewMode: 1,
            });
          });
        };
        reader.readAsDataURL(this.fileData);
      }
    },
    cropImage() {
      if (this.cropper) {
        const canvas = this.cropper.getCroppedCanvas();
        this.croppedImage = canvas.toDataURL("image/webp");
        this.visible = false;
      }
    },
  },
  created() {
    this.setBlogTitle();
    this.fetchBlog();
    this.fetch_categories();
    this.hashtag_categories();
  },
};
</script>

<style lang="scss" scoped>
.form-group {
  margin-bottom: 1rem;
}

.image_upload {
  width: 150px;
  height: 150px;
  margin-bottom: 1.5rem;

  .upload_img,
  .entry_image {
    width: 100%;
    height: 150px;

    img {
      width: 100%;
      height: 150px;
    }
  }
}

.blog_img {
  max-height: 300px;
}

.form-group {
  label {
    margin-bottom: 0.5rem;
  }
}

.main_header_style {
  margin-bottom: 0;
}
</style>
